export const gerAdminMetricsRoute = '/admin/site/metrics/';
export const getTemplateMetricsRoute = '/ext/get/templates/stats/';
export const syncTemplatesRoute = '/ext/sync/templates/';
export const assignTemplatesRoute = '/ext/assign/templates/';

export const deleteAdminEmployerRoute = '/admin/employers/delete/';
export const approveSpamAccountRoute = '/admin/fraudulent_jobs/authorize/';
export const approveBlockAccountRoute = '/admin/suspicious_companies/approve/';
export const blockSpamAccountRoute = '/admin/mark_suspicious_companies/';
export const gerAdminEmployersRoute = '/admin/employers/get';
export const gerAdminTemplatessRoute = '/ext/get/templates/';
export const gerAdminSpanAccountsRoute = '/admin/fraudulent_jobs/get/';
export const gerAdminBlockAccountsRoute = '/admin/suspicious_companies/get/';
export const gerAdminEnterprisesRoute = '/admin/enterprise/get';
export const getTrialCountRoute = '/admin/employers/trial/remaining';
export const getCompanySubscriptionDetailtRoute = '/admin/get_company_details/csv/';
export const getPaidCountRoute = '/admin/employers/paid/check/';
export const updateEmployerUrlRoute = '/admin/employers/url/edit/';
export const extendTrialRoute = '/admin/employers/trial/extend/';
export const gerAdminEmployersMetricsRoute = '/admin/employers/metrics';
export const adminRequestHitringGraphicsRoute = '/admin/hiringgraphic/';
export const getSubscriptionDetailRoute = '/admin/subscription/get';


export const gerAdminPositionRoute = '/admin/positions/get/';
export const createAdminPositionRoute = '/admin/position/add/';
export const editAdminPositionRoute = '/admin/position/edit/';
export const deleteAdminPositionRoute = '/admin/position/delete/';

export const cancelSubscriptionRoute = '/admin/subscription/cancel_suscription/';

export const gerAssignedIndustryRoute = '/admin/industry/assigned/';
export const gerAdminIndustriesRoute = '/admin/industries/get';
export const createAdminIndustryRoute = 'admin/industry/add/';
export const getSingleIndustrysRoute = '/admin/industry/assigned/';
export const editAdminIndustryRoute = '/admin/industry/edit/';
export const deleteAdminIndustryRoute = '/admin/industry/delete/';
export const assignedPositionToIndustryRoute = '/admin/industry/assign/positions/';

export const deactivateApplicantRoute = '/admin/applicants/deactivate/';
export const gerAdminApplicantsRoute = '/admin/applicants/get/';
export const gerAdminApplicantsMetricsRoute = '/admin/applicants/metrics/';
export const deleteAdminApplicantsRoute = '/admin/applicants/delete/';

export const adminChangePasswordRoute = '/admin/login/change_password';
export const loginUserRoute = '/admin/users/login/';
export const loginBackRoute = '/admin/users/login/back/';
export const adminsListrRoute = '/admin/admins/get/';
export const adminsUserCreateRoute = '/admin/admins/create/';
export const adminsUserDeleteRoute = '/admin/admins/delete/';


export const adminsEnterpriseCraete = '/admin/enterprise/create/';
export const deleteAdminEnetrpriseRoute = '/admin/enterprise/delete/';

export const adminWotcUserList = '/admin/wotc/get/';

export const adminUpdateLogo = '/admin/logo/'; 